import React, { useState } from 'react';

import { Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { Button, Modal } from '@betterment/style-closet-react';

import { trackClick } from '../../features/track';
import { urlBuilder } from '../../Shared/urlBuilder';

const FormCRSModal: React.FC = () => {
  const [shouldShowFormCRSModal, setShouldShowFormCRSModal] = useState(true);
  const closeModal = () => setShouldShowFormCRSModal(false);

  return (
    <>
      {shouldShowFormCRSModal && (
        <Modal closeHandler={closeModal} variant="new" data-testid="formCRSModal">
          <Modal.Slot name="heading"> Welcome back</Modal.Slot>
          <Modal.Slot name="content">
            <Text as="p">
              First time logging-in in a while? Please review our{' '}
              <SambaAutoLink
                onClick={() => trackClick({ module: 'WelcomeBackModal', name: 'FormCRS' })}
                to={urlBuilder.getLegalFormCrs()}
                target="_blank"
                rel="noopener noreferrer"
              >
                Form CRS
              </SambaAutoLink>
              ,{' '}
              <SambaAutoLink
                onClick={() => trackClick({ module: 'WelcomeBackModal', name: 'FormADV' })}
                to={urlBuilder.getLegalFormAdv()}
                target="_blank"
                rel="noopener noreferrer"
              >
                Form ADV Part II
              </SambaAutoLink>{' '}
              and{' '}
              <SambaAutoLink
                onClick={() => trackClick({ module: 'WelcomeBackModal', name: 'Other' })}
                to={urlBuilder.getLegalDisclosures()}
                target="_blank"
                rel="noopener noreferrer"
              >
                other disclosures
              </SambaAutoLink>
              .
            </Text>
          </Modal.Slot>
          <Modal.Slot name="actions">
            <Button onClick={closeModal}>Got it</Button>
          </Modal.Slot>
        </Modal>
      )}
    </>
  );
};

export default FormCRSModal;
